import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { Carousel } from '../../../subcomponents/carousel/carousel';
import { FilmThumbnailSkeleton } from '../../film/thumbnail/subcomponents/ui';
import { FilmTitleSkeleton } from '../../film/title/subcomponents/ui';
import { FilmListMode } from '../types/config';
import { FilmListContextInstance } from '../types/context';
const b = bemClassBuilder('v-film-list');
const bCarousel = bemClassBuilder('v-film-list-carousel');
const bGrid = bemClassBuilder('v-film-list-grid');
const bFilm = bemClassBuilder('v-film-list-film');
export const FilmListSkeleton = observer(() => {
    const { config } = useContext(FilmListContextInstance);
    const { mode } = config;
    return (_jsx("div", Object.assign({ className: b.block({ skeleton: true }) }, { children: mode === FilmListMode.Carousel ? _jsx(FilmListCarouselSkeleton, {}) : _jsx(FilmListGridSkeleton, {}) })));
});
FilmListSkeleton.displayName = 'FilmListSkeleton';
const FilmListCarouselSkeleton = () => {
    const { config: { carousel } } = useContext(FilmListContextInstance);
    return (_jsx("div", Object.assign({ className: bCarousel.block({ skeleton: true }) }, { children: _jsx(Carousel, Object.assign({ config: Object.assign(Object.assign({}, carousel), { disableScroll: true }) }, { children: [...Array(7)].map((_value, index) => (_jsx(FilmListFilmItemSkeleton, {}, index))) })) })));
};
FilmListSkeleton.displayName = 'FilmListCarouselSkeleton';
const FilmListGridSkeleton = () => {
    return (_jsx("div", Object.assign({ className: bGrid.block({ skeleton: true }) }, { children: [...Array(17)].map((_value, index) => (_jsx(FilmListFilmItemSkeleton, {}, index))) })));
};
FilmListSkeleton.displayName = 'FilmListGridSkeleton';
const FilmListFilmItemSkeleton = () => {
    const { config: { mediaType } } = useContext(FilmListContextInstance);
    return (_jsxs("div", Object.assign({ className: bFilm.block({ skeleton: true }) }, { children: [_jsx("div", Object.assign({ className: bFilm.element('thumbnail', { skeleton: true }) }, { children: _jsx(FilmThumbnailSkeleton, { mediaType: mediaType }) })), _jsx(FilmTitleSkeleton, {})] })));
};
FilmListSkeleton.displayName = 'FilmListFilmItemSkeleton';
